module.exports = __webpack_public_path__ + "img/9.cbb46bec.jpg";